import ContactService from "@/services/contact.service"

export default {
    state: {
    },
    getters: {
    },
    mutations: {
    },
    actions: {
        contact (_,params) {
          return ContactService.contact(params)             
        }
    },
}